import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios'
import {message} from 'antd'
import keyUri from '../../key'

export const initialState = {

    loading: false,
    hasErrors: false,
    resume:[],
    currentResume:null,
}

export const resumeSlice = createSlice({
    name:"resume",
    initialState,
    reducers:{

        getResume: state =>{

            state.loading = true
        },

        getResumeSuccess: (state, {payload}) =>{
          console.log("Inside this")
            state.loading = false
            state.resume = payload
            
        },

        getCurrentResume: (state, {payload}) =>{
            state.loading = false
            state.currentResume = payload
            
        },
        getResumeFailure: (state, {payload}) =>{

            state.loading = false
            state.resume = payload
            
        },

    }
})

export const {getResume, getResumeSuccess, getCurrentResume, getResumeFailure } = resumeSlice.actions
      
export const resumeSelector = state => state.resume
export default resumeSlice.reducer


const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };



export const  fetchAllResume = () => async dispatch =>{
      const key = "resume"
      dispatch(getResume())
      
    try {

        const {data} = await axios.get(keyUri.BACKEND_URI +'/resume');
        console.log(data)
        dispatch(getResumeSuccess(data))

    } catch ({response}) {

        dispatch(getResumeFailure())
        response.data && message.error({ content: response.data.msg, key, duration: 2 });

    }
    
}

export const  fetchOneResume = (id) => async dispatch =>{

    dispatch(getResume())
    
  try {

      const {data} = await axios.get(keyUri.BACKEND_URI +`/resume/${id}`);
      dispatch(getCurrentResume(data))

  } catch ({response}) {

      dispatch(getResumeFailure())
    //   response.data && message.error({ content: response.data.msg, key, duration: 2 });

  }
  
}


export const  createResume = (values) => async dispatch =>{
  console.log(values);
    const key = "resume"
    dispatch(getResume())
    message.loading({ content: 'loading...', key })
    
  try {

      const {data} = await axios.post(keyUri.BACKEND_URI +'/resume', values, config);
      setTimeout(() => {

        message.success({ content: data.msg, key, duration: 2 });
      }, 500) 
        dispatch(fetchAllResume())

  } catch ({response}) {
       dispatch(getResumeFailure())
  }
  
}


export const  deleteResume = (id) => async dispatch =>{
    const key = "resume"
    dispatch(getResume())
    message.loading({ content: 'loading...', key })
    
  try {

      const {data} = await axios.delete(keyUri.BACKEND_URI +`/resume/${id}`);
      data && message.success({ content: data.msg, key, duration: 2 });
      dispatch(fetchAllResume())

  } catch ({response}) {

      dispatch(getResumeFailure())
      response.data && message.error({ content: response.data.msg, key, duration: 2 });

  }
  
}


export const  updateResume = (id, values) => async dispatch =>{
    const key = "resume"
    dispatch(getResume())
    message.loading({ content: 'loading...', key })
    
  try {

      const {data} = await axios.put(keyUri.BACKEND_URI +`/resume/${id}`, values, config);
      data && message.success({ content: data.msg, key, duration: 2 });
      window.location.reload()
      dispatch(fetchAllResume())

  } catch ({response}) {

      dispatch(getResumeFailure())
      response.data && message.error({ content: response.data.msg, key, duration: 2 });

  }
  
}




